module.exports = __webpack_public_path__ + "img/Number=9.9e60566e.png";